import compose from 'lodash/fp/compose';

import { canUpdate, selectable } from '../plugins';
import PluggableModule from '../pluggable';
import notificationSettingsApi from '../../firebase/notificationSettings';

const notificationSettings = new PluggableModule('setting');

const ADD_EVENT = 'NOTIFICATION_SETTINGS_ADD_EVENT';
const ADD_NOTIFICATION = 'NOTIFICATION_SETTINGS_ADD_NOTIFICATION';
const DELETE_NOTIFICATION = 'NOTIFICATION_SETTINGS_DELETE_NOTIFICATION';

notificationSettings.addMutationTypes([
  ADD_EVENT,
  ADD_NOTIFICATION,
  DELETE_NOTIFICATION
]);

notificationSettings.extend({
  namespaced: true,
  state: {},
  mutations: {
    [ADD_EVENT](state, { title, description, slug, hasMultiple }) {
      state.selected = {
        ...state.selected,
        [slug]: {
          title,
          description,
          hasMultiple,
          notifications: [
            {
              timeDiff: 0,
              title: '',
              description: ''
            }
          ]
        }
      };
    },
    [ADD_NOTIFICATION](state, selectedEventKey) {
      state.selected = {
        ...state.selected,
        [selectedEventKey]: {
          ...state.selected[selectedEventKey],
          notifications: [
            ...state.selected[selectedEventKey].notifications,
            {
              timeDiff: 0,
              title: '',
              description: ''
            }
          ]
        }
      };
    },
    [DELETE_NOTIFICATION](state, { eventKey, notificationIndex }) {
      state.selected = {
        ...state.selected,
        [eventKey]: {
          ...state.selected[eventKey],
          notifications: state.selected[eventKey].notifications.filter(
            (_, i) => i != notificationIndex
          )
        }
      };
    }
  },
  actions: {
    async load({ dispatch }) {
      await dispatch('selectSetting');
    },
    addNewEvent({ commit }, data) {
      commit(ADD_EVENT, data);
    },
    addNotification({ commit }, data) {
      commit(ADD_NOTIFICATION, data);
    },
    deleteNotification({ commit }, data) {
      commit(DELETE_NOTIFICATION, data);
    },
    async updateSettings({ commit }, data) {
      commit(notificationSettings.con.SETTING_SUBMIT_INIT);
      try {
        await notificationSettingsApi.update(data);
        commit(notificationSettings.con.SETTING_SUBMIT_DONE);
      } catch (error) {
        commit(notificationSettings.con.SETTING_SUBMIT_DONE);
        throw error;
      }
    }
  }
});

const hop = compose(
  canUpdate(),
  selectable(notificationSettingsApi)
);

export default hop(notificationSettings);
